import createLogger from "vuex/dist/logger";

const logger = createLogger({
    collapsed: false, // auto-expand logged mutations
    filter(mutation, stateBefore, stateAfter) {
        // returns `true` if a mutation should be logged
        // `mutation` is a `{ type, payload }`
        // TODO: Temporarily disabled for debugging video upload - re-enable later
        return false;
    },
    transformer(state) {
        // transform the state before logging it.
        // for example return only a specific sub-tree
        return state;
    },
    mutationTransformer(mutation) {
        // mutations are logged in the format of `{ type, payload }`
        // we can format it any way we want.
        return mutation
    }
});


export default logger;